import script from "./AdminNoteList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminNoteList.vue?vue&type=script&lang=ts&setup=true"

import "./AdminNoteList.vue?vue&type=style&index=0&id=03954ec0&lang=css"

const __exports__ = script;

export default __exports__